export default __webpack_public_path__ + "static/media/section-noten.3582fa0f.webp";